





















































import { Component, Vue } from 'vue-property-decorator';
import {
  default as Navigation,
  NavigationObject,
} from './components/Navigation.vue';
import Slider from './components/Slider.vue';
import {
  default as Collection,
  CollectionObject,
} from './components/Collection.vue';
import Contact from './components/Contact.vue';
import Footer, { FooterObject, PageObject } from './components/Footer.vue';
import Configurator, {
  CollectionConfig,
  TypeConfig,
  ColorConfig,
  SizesConfig,
} from './components/Configurator.vue';
import Loading from './components/Loading.vue';
import axios from 'axios';
import { CollectionObject as Descriptions } from './components/CollectionDescription.vue';
import News from './components/News.vue';
import Brand from './components/Brand.vue';
import CookieLaw from 'vue-cookie-law';
import Modal from './components/Modal.vue';
import Location, { Marker } from './components/Location.vue';
import imagesLoaded from 'vue-images-loaded';

interface LoadingStatus {
  content: boolean;
  images: boolean;
}

@Component({
  components: {
    Navigation,
    Slider,
    Collection,
    Configurator,
    Contact,
    Footer,
    Loading,
    News,
    Brand,
    CookieLaw,
    Modal,
    Location,
  },
  directives: {
    imagesLoaded,
  },
  data: () => {
    const footerObjects: FooterObject[] = [
      {
        label: 'Mit Liebe entworfen',
        icon: 'far fa-heart',
      },
      {
        label: 'Robust und Stoßfest',
        icon: 'fas fa-shield-alt',
      },
      {
        label: 'Umwelt-freundlich',
        icon: 'fas fa-leaf',
      },
      {
        label: 'Deutsche Handarbeit',
        icon: 'far fa-hand-paper',
      },
      {
        label: 'Große Farbvielfalt',
        icon: 'fas fa-palette',
      },
      {
        label: 'Spühl-maschinenfest',
        img: require('./assets/dishwasher_safe.png'),
      },
    ];
    return {
      // Loaded by content.json
      nav: [],
      title: '',
      subtitle: '',
      descriptions: [],
      pages: {},
      backend: '',
      shops: [],
      images: [],
      collection: [],
      straws: [],
      // Hardcoded
      footerObjects,
      // Default Value
      status: {
        content: false,
        images: false,
      },
    };
  },
})
export default class App extends Vue {
  private status!: LoadingStatus;
  private language!: object;
  private nav!: NavigationObject[];
  private title!: string;
  private subtitle!: string;
  private descriptions!: Descriptions[];
  private backend!: string;
  private pages!: { [p in string]: PageObject };
  private shops!: Marker[];
  private collection!: CollectionObject;
  private straws!: CollectionObject;
  private images!: string[];

  private mounted() {
    axios
      .get('content.json')
      .then((v) => {
        const data = v.data;
        if (typeof data === 'object') {
          this.nav = data.navigation;
          this.title = data.title;
          this.subtitle = data.subtitle;
          this.descriptions = data.collections;
          this.backend = data.backend;
          this.pages = data.pages;
          this.shops = data.shops;
          this.images = data.slider;
          this.collection = data.overview.collections;
          this.straws = data.overview.straws;
          this.status.content = true;
        } else {
          try {
            JSON.parse(data);
            // tslint:disable-next-line:no-console
            console.log('Unexpected Error', data);
          } catch (e) {
            // tslint:disable-next-line:no-console
            console.log('Error parsing content', e);
          }
        }
      })
      .catch((v) => {
        // tslint:disable-next-line:no-console
        console.log('Error loading content', v);
      });
  }

  private loaded() {
    this.status.images = true;
  }

  private get loading() {
    return !this.status.images || !this.status.content;
  }
}
